import React from 'react';
import WaitList from '../../components/users/WaitList';
import { compose, lifecycle, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import _ from 'lodash';
import { store } from 'store/createStore';

import { checkPermission } from 'utils/credentials';
import { ROLES } from '../../../../../consts';
import API from '../../../../../utils/api';

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = state => {
  return {
    roles: _.get(state, 'auth.currentGroup.myRoles', 'default'),
  };
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('selectedTab', 'updateSelectedTab', 0),
  withState('tableRef', 'setTableRef', null),
  withState('dataReport', 'setDataReport', []),
  withHandlers({
    getWaitListUsers: props => (filter, per_page, page) =>
      API.getUserInteractions({
        type: 'waitlist',
        ...filter,
        per_page,
        page,
        from: props.dateFrom,
        to: props.dateTo,
        sort: 'createdAt',
      }).then(({ data }) => data || []),
  }),
  lifecycle({
    async componentDidUpdate(prevProps) {
      checkPermission(this, ROLES.ANALYTICS);
    },
    componentDidMount() {
      this.props.setTableRef(React.createRef());
    },
  })
);

export default enhance(WaitList);
